var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1240_21943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 13.1717L16.2437 8.92868C16.6342 8.53822 17.2673 8.53821 17.6577 8.92868C18.0482 9.31914 18.0482 9.95221 17.6577 10.3427L12.7078 15.2926C12.3173 15.6831 11.6841 15.6831 11.2936 15.2926L6.34372 10.3427C5.95325 9.95221 5.95325 9.31914 6.34372 8.92868C6.73418 8.53821 7.36725 8.53821 7.75772 8.92868L12.0007 13.1717Z",
    fill: "#2B2C82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1240_21943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownBlue);
export default __webpack_public_path__ + "static/media/icon-chevron-down-blue.1b5f4d56eeba70bb80b3ef86aa123e3f.svg";
export { ForwardRef as ReactComponent };